<template>
    <div>
        <MeasurementItem
            v-if="level"
            :title="level.title"
            :datetime="level.lastUpdated"
            :link-to="level.link"
        >
            <template #icon>
                <WaterLevelIcon width="24" height="24" />
            </template>

            <template #content>
                {{ $t('shared.measurements.level') }}:

                <h3 class="sensor-data-distance">
                    {{ level.value }}
                </h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-if="battery"
            :title="battery.title"
            :datetime="battery.lastUpdated"
            :link-to="battery.link"
        >
            <template #icon>
                <BatteryIcon
                    :battery-level-in-percent="battery.value"
                    :warn="false"
                    width="24"
                    height="24"
                />
            </template>

            <template #content>
                {{ $t('shared.measurements.battery') }}:

                <h3 class="sensor-data-percentage">
                    {{ battery.value }}
                </h3>
            </template>
        </MeasurementItem>

        <MeasurementItem
            v-else-if="batteryVoltage"
            :title="batteryVoltage.title"
            :datetime="batteryVoltage.lastUpdated"
            :link-to="batteryVoltage.link"
        >
            <template #icon>
                <BatteryIcon
                    width="24"
                    height="24"
                    :battery-level-in-percent="100"
                />
            </template>

            <template #content>
                {{ $t('shared.measurements.battery_voltage') }}:

                <h3 class="sensor-data-voltage">
                    {{ batteryVoltage.value }}
                </h3>
            </template>
        </MeasurementItem>
    </div>
</template>

<script>
import BatteryIcon from './icons/BatteryIcon'
import MeasurementItem from './MeasurementItem'
import MeasurementListHelper from '../mixins/MeasurementListHelper'
import WaterLevelIcon from './icons/WaterLevelIcon'

export default {
    name: 'LevelMeasurement',
    components: {
        BatteryIcon,
        MeasurementItem,
        WaterLevelIcon,
    },
    mixins: [MeasurementListHelper],
    computed: {
        battery() {
            return this.getMeasurementItem('battery')
        },
        batteryVoltage() {
            return this.getMeasurementItem('battery_voltage')
        },
        level() {
            return this.getMeasurementItem('level')
        },
    },
}
</script>
